/** Shared button variant type used by CustomButton and FileCard button layout */
export type ButtonVariant = 'white' | 'outlined' | 'primary' | 'accent';

export const BUTTON_VARIANTS: { value: ButtonVariant; label: string }[] = [
  { value: 'white', label: 'White' },
  { value: 'outlined', label: 'Outlined' },
  { value: 'primary', label: 'Primary' },
  { value: 'accent', label: 'Accent' },
];

/** Normalize legacy variant names (cta → primary) */
export const normalizeButtonVariant = (variant: string): ButtonVariant =>
  variant === 'cta' ? 'primary' : (variant as ButtonVariant);
